import React from 'react';
import Icon from '../Icon';
import SwitchBase from '../SwitchBase';
import { IconColors, IconBackgroundColors, } from '../../constants';
import MicLevel from '../MicLevel';
import MicOffIcon from '../../assets/icons/mic-off.svg';
const SwitchMic = ({ size, disabled, isActive, switchHandle, participantId, variant }) => {
    const activeElement = (<MicLevel participantId={participantId} level={0}/>);
    const inactiveElement = (<Icon size={size} color={IconColors.Primary} backgroundColor={IconBackgroundColors.Secondary} variant={variant}>
      <MicOffIcon />
    </Icon>);
    return (<SwitchBase activeElement={activeElement} inactiveElement={inactiveElement} isActive={isActive} disabled={disabled} switchHandle={switchHandle}/>);
};
export default SwitchMic;
